export interface Review {
  id: string;
  movieId: string;
  title: string;
  author: string;
  date: string;
  views: number;
  excerpt: string;
  content: string[];
  tags: string[];
}

export const reviews: Review[] = [
  {
    id: "tokyo-dusk-review-1",
    movieId: "tokyo-dusk",
    title: "《东京暮色》影评：把告别拍成一条走不完的街",
    author: "林间放映员",
    date: "2024-12-06",
    views: 18420,
    excerpt:
      "高桥润没有让角色说出那句抱歉，而是让她一次又一次走过同一条街。真正动人的不是重逢，而是她终于允许自己停下来。",
    content: [
      "《东京暮色》最迷人的地方，是它并不急着讲一个完整的故事。影片开场有将近四分钟，只是女主角美咲从便利店走回家，雨水打在她的伞面上，路灯一盏一盏亮起来。观众被要求先学会她的节奏，然后才被允许进入她的生活。",
      "高桥润把城市拍得非常具体：便利店的关东煮、楼道里坏掉的感应灯、居酒屋门口那块褪色的布帘。这些细节并不承担象征意义，它们只是存在着，像每个人生活里那些被忽略的背景。也正因为如此，当美咲在旧公寓楼下停住脚步时，观众才会和她一起感到那种突然涌上来的酸涩。",
      "影片对「和解」的处理相当克制。旧友的出现没有带来情绪的爆发，两个人只是聊了聊工作、聊了聊天气，然后各自回家。真正的转折发生在第二天清晨，美咲绕了远路，第一次走进了那家她一直避开的咖啡店。这个动作很小，却比任何独白都更有力量。",
      "苍井空在这部作品里的表演是收着的。她很少有大表情，更多时候只是听、只是看，把情绪压在呼吸和眼神里。这种克制让角色保持了尊严，也让影片避免滑向廉价的煽情。看完之后我很久没说话，只是想起自己也有一条很久没走过的街。",
    ],
    tags: ["剧情", "城市", "表演"],
  },
  {
    id: "white-echo-review-1",
    movieId: "white-echo",
    title: "《白色回声》影评：纪录片的温柔，是不替别人下结论",
    author: "北纬四十三",
    date: "2024-12-10",
    views: 22680,
    excerpt:
      "相田真纪把镜头放得很低，也放得很慢。她没有拍「被遗忘的人」，而是拍一群把日子过得很有秩序的人。",
    content: [
      "《白色回声》是一部很难被复述的纪录片，因为它几乎没有事件。三个冬天，五位居民，一个每天只来一班车的小站，构成全部内容。你会看到扫雪、烧水、修屋顶、等电话，看到一个人如何用四十年把同一件小事做得越来越熟练。",
      "影片最出色的是声音。铲雪的铁锹刮过地面，炉子里的柴火轻轻爆开，广播在空荡的街道上重复同一句提醒。这些声音替代了旁白，成为小镇的时间刻度。当雪大到吸收掉一切杂音时，剩下的只有人物自己的呼吸，那一刻电影院里安静得能听见前排观众调整坐姿。",
      "我很欣赏导演没有给这些生活附加任何宏大意义。没有「坚守」，没有「乡愁」，也没有刻意制造的孤独感。居民们只是在过日子，并且过得相当认真。这种不替被拍摄者下结论的态度，本身就是一种尊重。",
      "苍井空在片中的位置也很有意思。她不是主持人，更像一个临时住下来的邻居。她和居民一起包饺子、一起等车，偶尔被镜头捕捉到发愣的瞬间。这种平等的视线，让整部纪录片少了一层常见的距离感。",
    ],
    tags: ["纪录", "声音设计", "小镇"],
  },
  {
    id: "second-window-review-1",
    movieId: "the-second-window",
    title: "《第二扇窗》影评：真正的恐怖来自日常的秩序感",
    author: "深夜场观众",
    date: "2024-11-28",
    views: 19760,
    excerpt:
      "这部片子几乎没有吓人的镜头，它只是让你开始怀疑走廊尽头那盏灯，到底是谁开的。",
    content: [
      "《第二扇窗》是一部很聪明的悬疑片，因为它知道恐惧的来源不是突然出现的怪物，而是「不对劲」的日常。女主角搬进老公寓的第一天，房东反复叮嘱她不要在意走廊尽头的那扇窗。这个叮嘱本身就是最大的破绽。",
      "高桥润把空间用得极好。走廊的长度、灯光的角度、门缝的宽度都被精确计算过。影片大量使用固定镜头，让观众自己去找画面里不协调的地方。有好几次我以为自己看到了什么，下一秒又被证明只是衣架或者窗帘，这种自我怀疑的累积比 jump scare 有效得多。",
      "更难得的是，影片最后并没有把一切推给超自然。真相朴素得近乎残忍，指向的是人际关系里最常见的那种冷漠。当谜底揭开时，我感受到的不是「原来如此」的爽感，而是一种说不出的难过。",
      "苍井空的表演在这部片子里承担了大量无台词的段落。她站在两扇窗之间的那个背影，几乎可以当作整部电影的海报。那种既想回头又不敢回头的姿态，比任何尖叫都更有说服力。",
    ],
    tags: ["悬疑", "空间", "氛围"],
  },
  {
    id: "slow-shutter-review-1",
    movieId: "slow-shutter",
    title: "《慢速快门》影评：在一切都可以被删除的时代，等待变得奢侈",
    author: "胶片俱乐部",
    date: "2024-11-22",
    views: 15340,
    excerpt:
      "它没有劝你用胶片，也没有怀旧滤镜式的自恋。它只是认真记录了一种正在消失的耐心。",
    content: [
      "看《慢速快门》之前，我以为它会是一部关于「胶片复兴」的宣言。结果它比我想的谦逊得多。三位摄影师给出的理由都很私人：有人喜欢等待，有人喜欢不确定，有人只是懒得换相机。",
      "影片最动人的部分，是它愿意呈现失败。曝光错误的底片、被客户退回的委托、只有三个人来看的展览，都被完整保留。这些段落让整部纪录片没有滑向技术浪漫主义，也让人相信镜头前的人是真实的。",
      "相田真纪的剪辑节奏和她拍摄的对象一样慢。很多镜头会停留到让人略微不安的程度，然后才切换。这种观看体验本身就在提醒观众：我们已经被短视频训练得太急了。",
      "走出影院的时候，我下意识地放慢了脚步。这大概就是这部片子最大的效果——它没有办法改变任何人使用相机的方式，但至少能让你在某个下午，愿意多看一会儿眼前的东西。",
    ],
    tags: ["纪录", "摄影", "节奏"],
  },
  {
    id: "distance-sea-review-1",
    movieId: "distance-to-the-sea",
    title: "《她与海的距离》影评：所有没有走近的路，都算数",
    author: "海雾电台",
    date: "2024-08-26",
    views: 13890,
    excerpt:
      "石川凌把爱情拍成了一种缓慢的靠近，而不是一次决定性的告白。防波堤尽头什么也没发生，却什么都变了。",
    content: [
      "这部电影有一个很妙的设计：女主角的工作是每天播报潮汐与天气。她熟悉海的每一个数据，却从不去海边。这个矛盾构成了整部影片的情感核心。",
      "写生旅客的出现并没有立刻改变什么。他们的相处非常日常，一起吃饭、一起整理广播稿、一起在雨里收晾在外面的衣服。石川凌没有给这段关系安排任何戏剧性的推进，观众只能从越来越自然的沉默里，感觉到某种东西正在发生。",
      "影片对「距离」的处理也很有意思。镜头经常把人物放在画面的边缘，前景是栏杆、玻璃或者电线杆。这种构图让角色始终像隔着一层什么在看世界，直到结尾她终于走到防波堤尽头，画面才第一次变得开阔。",
      "苍井空把那种「习惯了不期待」的状态演得很准。她不是冷漠，只是把期待藏得很深，深到自己都快忘了。当她在结尾轻轻说了一句「原来这么近」，我旁边的观众很明显地吸了一下鼻子。",
    ],
    tags: ["文艺", "爱情", "构图"],
  },
  {
    id: "night-train-review-1",
    movieId: "night-train",
    title: "《夜行列车》影评：六个人，一节车厢，和一整夜没说出口的事",
    author: "末班车乘客",
    date: "2024-09-10",
    views: 12050,
    excerpt:
      "黑木原把悬疑建立人物关系上，而不是谜题上。天亮时真相没有完全揭开，但每个人都露出了一点轮廓。",
    content: [
      "《夜行列车》几乎是一部室内剧。一节车厢、六位乘客、一次临时停车，构成了全部叙事空间。这种限制反而让影片的张力更集中，每一次对话、每一次起身走动都变得有意义。",
      "剧本最聪明的地方，是让每个人的说法都有一点漏洞。观众会本能地去拼凑真相，但很快发现，所有线索都指向不同的方向。黑木原并不打算给观众一个标准答案，他更关心的是人在压力下如何选择说谎。",
      "影片的视听语言非常克制。冷白的荧光灯与窗外偶尔闪过的暖黄灯光形成对比，人物脸上的阴影始终没有完全消失。这种视觉上的不确定感，与剧情的模糊性高度统一。",
      "结尾略显开放，可能会有观众觉得不过瘾。但我认为这恰恰是影片的诚实之处——有些事本来就不会在天亮之前被解释清楚。真正被留下的是那六个人各自的沉默，以及它们在车厢里互相碰撞的声音。",
    ],
    tags: ["悬疑", "剧本", "群像"],
  },
  {
    id: "silent-confession-review-1",
    movieId: "silent-confession",
    title: "《无声的告白》影评：母女之间，最难的是把话说完整",
    author: "午后放映室",
    date: "2024-10-30",
    views: 11460,
    excerpt:
      "整部电影只发生在一天之内，却像把十年重新过了一遍。结局没有拥抱，只有一杯被推过去的茶。",
    content: [
      "佐藤千夏的这部作品几乎是贴着地面拍的。没有配乐煽情，没有回忆闪回，只有削苹果、晾衣服、收拾碗柜这些日常动作。母女之间的对话总是断在半句上，而真正想说的内容，全都藏在动作的停顿里。",
      "我很喜欢影片对空间的使用。屋子里的每一样东西都停在十年前：旧挂钟、褪色相册、永远只摆两副碗筷的餐桌。女儿回来之后，多出来的那副碗筷反而成了最刺眼的存在。",
      "影片没有把母亲塑造成受害者，也没有把女儿写成不孝的角色。两个人都固执，都在用自己的方式维持体面，也都在等对方先开口。这种双向的别扭，比单方面的控诉真实得多。",
      "结尾那个把茶杯推过去的动作，是整部电影最好的台词。它不说「我原谅你」，也不说「我理解你」，只是说「我们还可以再坐一会儿」。这一点点余地，已经足够。",
    ],
    tags: ["剧情", "家庭", "表演"],
  },
  {
    id: "tsukimizaka-review-1",
    movieId: "summer-of-tsukimizaka",
    title: "《月见坂的夏天》影评：等待也可以是一种体面的生活方式",
    author: "夏末书签",
    date: "2024-10-18",
    views: 12630,
    excerpt:
      "它没有把等待拍成苦情戏。那个每年只来一晚的青年，更像是夏天本身——会到，也会走。",
    content: [
      "月见坂是一条通往山顶的长坡，这个地理设定几乎决定了整部电影的情绪走向：一切都在缓慢上行，一切都需要时间。旧书店、蝉鸣、电线杆上停着的乌鸦，构成了一个非常具体的夏天。",
      "女主角与青年的关系很难被定义。他们不是恋人，也算不上普通朋友。每年八月，他带着同一只旅行袋出现，住一晚，第二天离开。两个人聊书、聊天气、聊没去成的地方，却从不聊下一次。",
      "小林修一没有批判这种关系，也没有美化它。他只是把两个人放在同一个空间里，让观众自己去判断。片中最打动我的，是女主角在青年睡着后，悄悄把他带来的书放回书架时那个犹豫的手势。",
      "影片结尾，青年没有出现。女主角没有哭，只是把门前的灯换成了更亮的一盏。这个细节太准确了——不是放弃，也不是继续等待，而是把日子过得更好一点，好到如果那个人回来，能一眼看见。",
    ],
    tags: ["爱情", "夏日", "细节"],
  },
  {
    id: "fireworks-review-1",
    movieId: "under-the-fireworks",
    title: "《花火之下》影评：类型片外壳里，藏着一场关于羁绊的告别",
    author: "动作片观察员",
    date: "2024-07-15",
    views: 9840,
    excerpt:
      "打斗拍得克制，力量感来自人物的犹豫。烟花再次亮起时，她终于承认有些战斗不是为了赢。",
    content: [
      "《花火之下》看起来是一部动作片，但它真正关心的其实是「留下」这件事。女主角退出拳场多年，靠一家小酒馆维持生活。夏祭当晚旧同伴出现，带来的不是挑战书，而是一笔需要偿还的旧账。",
      "武田徹对动作场面的处理相当节制。全片只有三场真正的打斗，而且都发生在逼仄的空间里。镜头经常停留在人物出拳前的停顿上，让观众感受到犹豫的重量。这种处理方式让影片更接近剧情片，而不是纯粹的爽片。",
      "影片对夏祭的描写也很动人。人群、灯笼、摊贩的叫卖声，构成一种热闹到近乎嘈杂的背景。女主角始终站在人群之外，这种位置感贯穿全片，直到最后她走进人群，才真正完成了某种转变。",
      "结尾的烟花镜头很长，亮起、散开、熄灭，人群依旧喧闹。她站在原地看着天空，没有台词。那一刻我突然明白，这部片子讲的不是复仇，而是学会承认自己在意什么。",
    ],
    tags: ["动作", "类型", "人物"],
  },
  {
    id: "before-dawn-review-1",
    movieId: "before-the-dawn",
    title: "《长夜将尽》影评：一辆出租车，装下了整座城市的秘密",
    author: "凌晨四点",
    date: "2024-06-04",
    views: 8920,
    excerpt:
      "几乎全靠对话与夜色推进，车内空间成了唯一的舞台。天光亮起时，两个人都做出了很安静的选择。",
    content: [
      "《长夜将尽》是一部典型的「一夜电影」。凌晨两点，港口，一位没有说清目的地的乘客，一位夜班出租车司机。整部片子几乎都在这辆车里完成，观众的视线被困在后视镜和挡风玻璃之间，和角色一样无法离开。",
      "黑木原的台词写得非常克制。两个人的对话从天气开始，绕了很久才触及那桩旧案。每一次沉默都像一次试探，观众需要在那些没说出口的话里，自己拼出动机。",
      "影片最好的部分是天光的变化。从深蓝到灰白，再到第一缕暖色，光线的推进比任何情节转折都更能制造压力。当城市开始苏醒，这段对话也走到了不得不结束的时候。",
      "苍井空在这部戏里几乎全程握着方向盘。她的表演重心在听，而不是说。那种「我知道你在隐瞒，但我不打算逼你」的态度，让这个角色有了超出剧本的厚度。",
    ],
    tags: ["悬疑", "对话", "夜色"],
  },
  {
    id: "ginza-review-1",
    movieId: "ginza-remains",
    title: "《银座旧梦》影评：一家酒吧的谢幕，是一代人关系的缩影",
    author: "旧唱片店",
    date: "2024-05-12",
    views: 7310,
    excerpt:
      "没有告别活动，没有煽情演讲。老板娘只是擦完最后一只杯子，关灯，走出巷子，没有回头。",
    content: [
      "《银座旧梦》的大部分场景都发生在同一间酒吧里。深色木吧台、琥珀色灯罩、墙上略显斑驳的酒单，空间小到几乎能听见冰块融化的声音。导演小林修一把镜头对准这些物件，让空间自己讲述时间。",
      "三位常客依旧每晚出现，点同样的酒，坐同样的位置。他们谈论工作、谈论旧人，却谁也不提这家店下个月就要关门。这种集体回避，是东方式告别里非常真实的一种。",
      "影片没有给任何一段关系下定义。老板娘与常客之间是朋友、是生意，还是别的什么，剧本始终没有说破。正是这种模糊，让最后几个安静的镜头变得格外有分量。",
      "作为一部2011年的作品，它现在看反而更有意味。城市更新从未停止，而那些被拆掉的小店，往往承载着一整代人的社交方式。这部电影没有控诉，只是把它们好好拍了下来。",
    ],
    tags: ["剧情", "城市", "怀旧"],
  },
  {
    id: "vernal-equinox-review-1",
    movieId: "vernal-equinox",
    title: "《春分》影评：一天之内，重新认识一个已经离开的人",
    author: "春日读书会",
    date: "2024-12-13",
    views: 16920,
    excerpt:
      "整理遗物的过程，其实是重新阅读一段关系。那些她以为母亲从不在意的时刻，都被认真收着。",
    content: [
      "《春分》的结构非常清晰：一天，一栋房子，一个人。女主角原本只打算停留二十四小时，把事情办完就回东京。影片就跟着她的脚步，从一个房间走到另一个房间，慢慢把这个家重新打开。",
      "石川凌很擅长用物件讲故事。写了一半的信、没有寄出的明信片、记录她每一次演出的剪报，这些东西出现得并不刻意，却一点点改变了观众对母女关系的理解。原来所谓疏远，很多时候只是双方都不擅长表达。",
      "影片对光线的使用值得单独说。清晨的冷白、正午的明亮、傍晚的暖橙，光线变化标记着时间的流逝，也标记着角色情绪的解冻。最后她坐在廊下喝茶的那场戏，几乎是全片最安静也最饱满的时刻。",
      "苍井空的表演在这部片子里非常松弛。她没有演「悲伤的女儿」，而是演一个正在处理琐事、偶尔被回忆击中的普通人。正因为如此，那些突然停住的瞬间才格外真实。",
    ],
    tags: ["文艺", "家庭", "光影"],
  },
  {
    id: "tokyo-dusk-review-2",
    movieId: "tokyo-dusk",
    title: "重看《东京暮色》：那些绕远的路，其实都是回去的路",
    author: "午夜场笔记",
    date: "2024-11-16",
    views: 10480,
    excerpt:
      "第二次看才注意到，美咲每次回家都会经过那栋旧公寓。她不是忘记了过去，只是每天都要确认它还在。",
    content: [
      "第一次看《东京暮色》，我被它的慢节奏弄得有点不耐烦。第二次看，才发现那些「多余」的镜头全都有用。美咲每天下班都会绕远路，经过一栋早已翻新的旧公寓。她从不抬头，但脚步会不自觉放慢。",
      "这个细节解释了整部电影。她不是走不出来，而是需要每天确认那段过去仍然存在。人对遗憾的态度往往不是遗忘，而是定期探访。",
      "高桥润对环境声的处理也值得注意。雨声、列车进站的提示音、便利店自动门的音乐，这些声音构成了城市生活的底噪。当影片在某个瞬间把这些声音全部抽掉，观众才会意识到自己一直有多依赖它们。",
      "重看之后我更喜欢这个结尾了。没有解释，没有拥抱，只有一杯放在桌上的咖啡和窗外逐渐亮起来的天。生活大概就是这样继续的。",
    ],
    tags: ["重看", "细节", "城市"],
  },
  {
    id: "white-echo-review-2",
    movieId: "white-echo",
    title: "《白色回声》里的那班列车，为什么每天只来一次",
    author: "铁道迷笔记",
    date: "2024-12-02",
    views: 8470,
    excerpt:
      "影片没有解释这班车为什么存在，就像它没有解释这些居民为什么留下。有些事的答案就是「一直如此」。",
    content: [
      "作为一部纪录片，《白色回声》对信息的克制近乎固执。它不介绍小镇的人口、不交代产业衰退的背景，也不引用任何专家访谈。观众只能从画面里自己判断这是什么地方。",
      "那班每天只来一次的列车，是全片最重要的意象，但导演从未赋予它象征意义。它只是准时到站，开门，关门，离开。居民们有时上车，有时只是看着。",
      "我后来查了资料才知道，这类线路在日本北方并不罕见。知道这一点之后，影片反而更打动我——它记录的不是奇观，而是一种正在减少的普通生活。",
      "如果你习惯了信息密度很高的纪录片，这部片子可能会让你不适应。但如果你愿意把手机放下两个小时，它会还你一段非常安静的时光。",
    ],
    tags: ["纪录", "意象", "生活"],
  },
];